module.exports = __webpack_public_path__ + "img/order_btn_icon.a53b2983.svg";